import { render } from "./updateWarehouse.vue?vue&type=template&id=3c3f9318&scoped=true"
import script from "./updateWarehouse.vue?vue&type=script&lang=js"
export * from "./updateWarehouse.vue?vue&type=script&lang=js"

import "./updateWarehouse.vue?vue&type=style&index=0&id=3c3f9318&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3f9318"]])

export default __exports__